'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var textMaskCore = require('text-mask-core');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var nthHookTheme = require('@narvar/nth-hook-theme');
var TextInput = require('@narvar/nth-block-text-input');
var Select = require('@narvar/nth-block-select');
var flags = require('./lib/flags.js');
var smsCountry = require('./lib/smsCountry.js');
var TelephoneInput_module = require('./TelephoneInput.module.css.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);
var Select__default = /*#__PURE__*/_interopDefaultLegacy(Select);

const domesticCountries = ['US', 'CA'];
// need to add theme error styling
const TelephoneInput = ({
  label,
  title = 'Telephone Number',
  centered = false,
  error = false,
  disabled,
  onChangeCallback,
  featureName,
  s = {},
  placeholder,
  ariaLabelledby
}) => {
  const {
    smsDefaultCountry,
    smsSupportedCountries
  } = nthHookGlobalSettings.useGlobalSettings();
  const {
    countryDropdownAriaLabel
  } = nthHookTranslations.useTranslations();
  const {
    telephoneinputNoneNone: telephoneInputStyle
  } = nthHookTheme.useTheme();
  const {
    state: {
      localeCountry
    }
  } = nthHookContextPage.usePageContext();
  const defaultCountry = smsDefaultCountry || (smsCountry.isSmsCountry(localeCountry) ? localeCountry : 'US');
  const international = !domesticCountries.includes(defaultCountry);
  const [selectedCountry, setSelectedCountry] = React.useState(flags.mappedFlags[defaultCountry]);
  const [number, setNumber] = React.useState('');
  const [focused, setFocused] = React.useState(false);
  const handleFocus = () => {
    setFocused(true);
  };
  const handleBlur = () => {
    setFocused(false);
  };
  React.useEffect(() => {
    const {
      dialCode,
      mask = flags.defaultMask
    } = selectedCountry;
    const phoneNumber = number.replace(/\D/g, '');
    const {
      conformedValue
    } = textMaskCore.conformToMask(phoneNumber.length > 10 ? phoneNumber.substr(0, 10) : phoneNumber, mask, {
      guide: false,
      previousConformedValue: phoneNumber
    });
    if (onChangeCallback) {
      onChangeCallback(`${international ? dialCode : ''}${phoneNumber}`);
    }
    setNumber(international || !mask.length ? phoneNumber : conformedValue);
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [number]);
  React.useEffect(() => {
    if (!defaultCountry) return;
    setSelectedCountry(flags.mappedFlags[defaultCountry]);
  }, [defaultCountry]);
  const containerStyle = {
    ...telephoneInputStyle,
    ...(focused ? {
      borderColor: '#111'
    } : s)
  };
  const handleCountrySelectChange = option => {
    const flag = flags["default"].find(flag => flag.code === option?.value ?? 'US');
    if (!flag) return;
    setSelectedCountry(flag);
  };
  const handleCountrySelectFocus = () => {
    setFocused(true);
  };
  const handleCountrySelectBlur = () => {
    setFocused(false);
  };
  const flagOptions = flags["default"].filter(({
    code
  }) => !smsSupportedCountries || !smsSupportedCountries.length || smsSupportedCountries?.includes(code)).map(({
    code,
    emoji,
    name
  }) => ({
    value: code,
    label: `${emoji} ${name}`
  }));
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: TelephoneInput_module["default"].inputContainer,
    "data-testid": "telephone-input-container",
    style: containerStyle
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: TelephoneInput_module["default"].tableContainer
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: TelephoneInput_module["default"].cellContainer
  }, international && /*#__PURE__*/React__default["default"].createElement(Select__default["default"], {
    name: "country-selector",
    options: flagOptions,
    label: countryDropdownAriaLabel ?? '',
    hideLabel: true,
    value: flagOptions.find(flag => flag.value === selectedCountry.code),
    valueRender: selectedCountry.emoji,
    style: {
      container: {
        margin: 0,
        width: '3rem',
        height: '2rem',
        padding: '0.1875rem'
      },
      control: {
        border: 0,
        height: '100%',
        padding: '0 0.25rem'
      },
      selected: {
        fontSize: '1.25rem'
      }
    },
    system: true,
    outline: true,
    onChange: handleCountrySelectChange,
    onFocus: handleCountrySelectFocus,
    onBlur: handleCountrySelectBlur
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    "data-test": "telephoneInputNumberContainer",
    className: international ? TelephoneInput_module["default"].cellInternational : undefined
  }, /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
    containerOverridesStyle: {
      border: 'none'
    },
    label: label,
    id: label,
    type: TextInput.SupportedInputType.tel,
    value: number,
    onChange: event => setNumber(event.target.value),
    error: error,
    centered: centered,
    maxLength: 14,
    title: title,
    animateLabel: true,
    featureName: featureName,
    disabled: disabled,
    onFocus: handleFocus,
    onBlur: handleBlur,
    placeholder: placeholder,
    ariaLabelledby: ariaLabelledby
  }))));
};
var TelephoneInput$1 = nthHookGlobalSettings.withGlobalSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(TelephoneInput, {
  themeTokens: ['telephoneinputNoneNone', 'bodytextDefaultNone']
}), {
  translationKeys: ['countryDropdownAriaLabel']
}), {
  globalSettingsRequested: `
      smsDefaultCountry
      smsSupportedCountries
    `
});

exports.isSmsCountry = smsCountry.isSmsCountry;
exports["default"] = TelephoneInput$1;
exports.domesticCountries = domesticCountries;
